"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var apisauce_1 = tslib_1.__importDefault(require("apisauce"));
var config_1 = tslib_1.__importDefault(require("./config"));
var TIMEOUT = config_1.default.TIMEOUT;
var instances = {};
var create = function (authToken, baseURL) {
    var instanceId = baseURL + authToken;
    if (typeof instances[instanceId] !== 'undefined')
        return instances[instanceId];
    var api = apisauce_1.default.create({
        baseURL: "".concat(baseURL),
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: TIMEOUT
    });
    var getTemplates = function () {
        return api
            .get('')
            .then(function (response) {
            if (response.ok && response.data) {
                return {
                    data: response.data
                };
            }
            else {
                throw response.problem || response.data;
            }
        });
    };
    instances[instanceId] = {
        getTemplates: getTemplates
    };
    return instances[instanceId];
};
exports.default = {
    create: create
};
